export const LOCALE_IT = {
    ORDER: "Ordine",
    INVOICE: "Fattura",
    INVOICES: "Fatture",
    PROFORMA_INVOICES: "Fatture proforma",
    CREDIT_NOTE: "Nota di credito",
    CREDIT_NOTES: "Note di credito",
    CREATION_DATE: "Data di emissione",
    DELIVERY_DATE: "Data di consegna",
    DELIVERY_ADDRESS: "Indirizzo di consegna",
    DELIVERY_COST: "Spese di consegna",
    VENDOR: "Fornitore",
    CUSTOMER: "Cliente",
    ORDER_NUMBER: "Numero d'ordine",
    PAYMENT_METHOD: "Metodo di pagamento",
    NOTE: "Nota",
    PRODUCT: "Articolo",
    PRODUCT_DESCRIPTION: "Descrizione",
    PRODUCT_AMOUNT: "Quantità",
    PRODUCT_SINGLE_PRICE: "Prezzo unitario",
    DISCOUNT: "Sconto",
    TOTAL_DISCOUNTS: "Totale sconto",
    TOTAL_BEFORE_DISCOUNTS: "Totale esclusa sconto",
    TAX_ABBREVIATED: "IVA",
    TAX_AMOUNT: "Importo dell'imposta",
    SPLIT_AMOUNT: "Importo suddiviso",
    BRUTTO: "Prezzo Lordo",
    TOTAL: "Prezzo Totale",
    TOTAL_INCLUDING_VAT: "Totale IVA inclusa",
    TOTAL_EXCLUDING_VAT: "Totale IVA esclusa",
    VAT_ID: "Partita IVA",
    TAX_ID: "Imposta n.",
    PAID: "Pagato",
    UNPAID_AMOUNT: "Importo non saldato",
    REASON: "Motivo",
    INVOICE_LINE_ITEMS_TITLE: "Ordina gli articoli",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Note di credito su articoli d'ordine",
    OTHER_CREDIT_NOTES: "Personalizzazione dell'ordine",
    REFUND_SHIPPING_COST: "Costo riturno",
    REFUND_HAS_BEEN_PAID: "È stato emesso un rimborso dell'importo di $VALUE.",
    REFUND_HAS_BEEN_PAID_FAILED: "Il rimborso di un pagamento di $VALUE è fallito.",
    DOCUMENTS_FOR_ORDER: "Documenti per l'ordine",
    NO_INVOICES: "Non ci sono ancora fatture",
    NO_CREDIT_NOTES: "Non ci sono ancora note di credito",
    DOCUMENTS_ARE_GENERATING: "I documenti vengono generati. Riprovare tra qualche minuto.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "Non abbiamo trovato alcun documento per questo ordine. Si prega di inviare una mail a support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC:
        "Non abbiamo trovato alcun documento per questo ordine. Si prega di inviare una mail al commerciante",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "Non abbiamo trovato alcun documento per questo ordine. Si prega di inviare una mail a ${MAIL}",
    GIFT_CARD_LINE: "Per questo ordine è stato utilizzato un codice voucher${GIFT_CARD_CODE} da ${GIFT_CARD_AMOUNT}",
    GIFT_CARD: "Voucher",
    REVERSAL_INVOICE: "Fattura di annullamento",
    REVERSAL_CREDIT_NOTE: "Annullamento della nota di credito",
    DUTY: "Dazio doganale",
    USED_DISCOUNTS: "Sconti applicati",
    PAYMENT_AT: "Pagamento il $DATE",
    REFUNDED_CREDITNOTE_AT: "Rimborso della nota di credito $CREDIT_NOTE il $DATE",
    REFUNDED_AT: "Rimborso il $DATE",
    PROCESSING_DOCUMENT: "Documento in elaborazione",
    DOWNLOAD_DOCUMENTS_TITLE: "Scarica i tuoi documenti qui!",
    MAIL_INTRODUCTION: "Per qualsiasi domanda, contattare ${MAIL}",
    REPAYMENT_DIFFERENCE: "Differenza di rimborso",
    DOCUMENT_PREVIEW_BANNER: "Anteprima – scarica il PDF",
};
